import React from 'react';
import { withRouter } from 'react-router-dom';

import work_image002 from './imgs/work_image002.jpg';
import toolbar_image003 from './imgs/toolbar_image003.png';
import work_image005 from './imgs/work_image005.jpg';
import work_image006 from './imgs/work_image006.png';
import toolbar_image008 from './imgs/toolbar_image008.jpg';
import lungdis_help2211 from './imgs/lungdis_help2211.png';
import lungdis_help2328 from './imgs/lungdis_help2328.png';
import lungdis_help2550 from './imgs/lungdis_help2550.png';
import lungdis_help2688 from './imgs/lungdis_help2688.png';
import './help.css';
const WorklistHelp = props => {
  return (
    <div className="lung-body">
      <div className="lung-help">
        <p className="title">基本操作说明</p>
        <p className="img">
          <img src={work_image002} alt="" />
        </p>
        <p className="bold">在页面顶部左侧有基本功能列表，其功能如下：</p>
        <p className="bold">
          检查/历史/缩放/放大镜/调窗/移动/负相/向右旋转/左右翻转/上下翻转/重置/工具/下载/布局
        </p>
        <p className="img">
          <img src={toolbar_image003} alt="" />
        </p>
        <p className="first">检查：隐藏“序列”内容，显示影像。</p>
        <p className="first">
          历史：序列栏看诊的历史时间，单击“时间”，展示患者的历史影像。
        </p>
        <p className="first">缩放：按住鼠标左键移动进行放大/缩小影像。</p>
        <p className="first">放大镜：</p>
        <p className="second">按住鼠标左键，影像上显示放大镜区域。</p>
        <p className="second">
          放大镜区域会跟随鼠标移动，且不会移动到影像窗口外部。
        </p>
        <p className="second">
          放大镜不会被标记框所遮盖，聚焦内容将只显示影像。
        </p>
        <p className="first">调窗：按住鼠标左键移动调节明暗对比度。</p>
        <p className="first">移动：按住鼠标左键拖动可移动影像。</p>
        <p className="first">负相：单击后影像反色，正负片。</p>
        <p className="first">向右旋转：影像片向右旋转90°。</p>
        <p className="first">左右翻转：将影像片从左向右或从右向左180度翻转。</p>
        <p className="second">
          翻转后，原左边的影像在右边展示，原右边的影像在左边显示。
        </p>
        <p className="first">上下翻转：从上向下或从下向上180度翻转。</p>
        <p className="first">
          重置：在“缩放”、“放大镜”、“调窗”、“移动”、“负相”、“向右旋转”、“左右翻转”、“上下翻转”操作后，单击“重置”进行复位，影像恢复到操作之前。
        </p>
        <p className="first">
          工具：在影像片上单击起点，拖动到终点，释放鼠标，可以测量出实际两部位之间的距离，并在影像片上标记出。
        </p>
        <p className="second">
          在测量线上右击“删除”，可删除测量标记，单击“工具 &gt;
          清除”，可清除所有测量标记。
        </p>
        <p className="first">下载：可下载影像片。</p>
        <p className="first">布局：可选择1*1布局、1*2布局、2*1布局、2*2布局</p>
        <p className="bold border">序列</p>
        <p className="img">
          <img src={work_image005} alt="" />
        </p>
        <p className="first">左侧序列栏将会显示该患者所有检查影像。</p>
        <p className="first">
          单击左侧任意影像，系统将影像放大显示在主显示区域。
        </p>
        <p className="img">
          <img src={work_image006} alt="" />
        </p>
        <p>
          AI分析诊断，如果出现AI值大于50°，为阳性，单击右上角的图标，系统跳转到诊断筛查页面。
        </p>
        <p className="title">质控示教</p>
        <p>医技人员可以查看系统提供的影像拍片操作指导。</p>
        <p className="img">
          <img src={toolbar_image008} alt="" />
        </p>
        <p>
          系统显示人体部位包括：下肢、头部、胸部、脊柱、骨盆、腹部、上肢、下肢、头部。单击每个部位，显示该部位的器官，例如胸部包含：胸骨、心脏、肺部、肋骨。
        </p>
        <p className="img">
          <img src={lungdis_help2211} alt="" />
        </p>
        <p className="img">
          <img src={lungdis_help2328} alt="" />
        </p>
        <p>
          例如，单击“肺部“，系统显示各种体位，包含：肺部站立前凸位（前弓-前后位）、肺部
          站立前凸位（前弓-后前位）、肺部站立后前位、肺部站立侧位、肺部仰卧前后位、肺部侧
          卧后前位、肺部仰卧水平侧位、肺部半卧前后位。
        </p>
        <p className="img">
          <img src={lungdis_help2550} alt="" />
        </p>
        <p>单击其中一种体位，系统显示体位设计页面。</p>
        <p className="img">
          <img src={lungdis_help2688} alt="" />
        </p>
        <p className="first">单击“查看质控要点”。</p>
        <p className="first">单击“示教音频”，收听示教指导讲解。</p>
      </div>
    </div>
  );
};

export default withRouter(WorklistHelp);
